var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 41,
    viewBox: "0 0 31 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4062 8.19727C30.1094 8.97852 30.5 9.83789 30.5 10.8535V36.791C30.5 37.8848 30.1094 38.7441 29.4062 39.4473C28.625 40.2285 27.7656 40.541 26.75 40.541H4.25C3.15625 40.541 2.29688 40.2285 1.59375 39.4473C0.8125 38.7441 0.5 37.8848 0.5 36.791V4.29102C0.5 3.27539 0.8125 2.41602 1.59375 1.63477C2.29688 0.931641 3.15625 0.541016 4.25 0.541016H20.1875C21.2031 0.541016 22.0625 0.931641 22.8438 1.63477L29.4062 8.19727ZM27.6094 9.99414L21.0469 3.43164C20.8906 3.27539 20.6562 3.19727 20.5 3.04102V10.541H28C27.8438 10.3848 27.7656 10.1504 27.6094 9.99414ZM26.75 38.041C27.0625 38.041 27.375 37.9629 27.6094 37.7285C27.8438 37.4941 28 37.1816 28 36.791V13.041H19.875C19.3281 13.041 18.8594 12.8848 18.5469 12.4941C18.1562 12.1816 18 11.7129 18 11.166V3.04102H4.25C3.85938 3.04102 3.54688 3.19727 3.3125 3.43164C3.07812 3.66602 3 3.97852 3 4.29102V36.791C3 37.1816 3.07812 37.4941 3.3125 37.7285C3.54688 37.9629 3.85938 38.041 4.25 38.041H26.75Z",
    fill: "#706D6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.6deeceffaee26298f81f5bc4557f6982.svg";
export { ForwardRef as ReactComponent };